import { reduce } from 'lodash'
import { getRgba } from './ResearchTypesUtils'

const getSiteTypesSelected = (listOfThemes) => {
	const reduceTypes = reduce(listOfThemes, (result, theme) => {
		if (theme.value.siteTypes) {
			theme.value.siteTypes.forEach((o) => {
				if (result[o.type]) {
					result[o.type] = result[o.type] + 1
				} else {
					result[o.type] = 1
				}
			})
		}
		return result
	}, {})
	return Object.keys(reduceTypes).map((o) => {
		return o
	})
}

const getColor = (listOfThemes, childrenTheme, opacity = 0.3) => {
	const result = listOfThemes.find(a => {
		const themeFound = a.themes.find(b => {
			return b.id == childrenTheme.id
		})
		if (themeFound) {
			return a
		}
		return null
	})
	if (result) {
		return getRgba(result.color, opacity)
	}
	return getRgba('3, 169, 244', opacity)
}

export { getSiteTypesSelected, getColor }



// WEBPACK FOOTER //
// ./src/utils/ThemesUtils.js